import { Anchoring } from './Anchoring';
export default class AnchoringRoundData extends Anchoring {
    chainLength;
    chainShake;
    chainLeading;
    chainGrowing;
    constructor(anchor, chainLength, chainShake, chainLeading, chainGrowing, freeText) {
        super(anchor, freeText);
        this.chainLength = chainLength;
        this.chainShake = chainShake;
        this.chainLeading = chainLeading;
        this.chainGrowing = chainGrowing;
    }
}
//# sourceMappingURL=AnchoringRoundData.js.map